import { Component, EventEmitter, forwardRef, HostListener, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { COUNTRIES, Country, COUNTRY_CODES, CountryDropdown } from '../../interfaces/country.interface';

@Component({
  selector: 'wire-phone-input',
  templateUrl: './wire-phone-input.component.html',
  styleUrls: ['./wire-phone-input.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => WirePhoneInputComponent),
    multi: true
  }]
})
export class WirePhoneInputComponent  implements ControlValueAccessor {
 
  @Output() phoneNumberChange = new EventEmitter<string>();
  @Output() countryChange = new EventEmitter<string>();
  @Input() set initialValue(value: { countryCode: string; mobile: string } | null) {
    if (value) {
      this.updateValues(value);
    } else {
      this.selectedCountry = COUNTRY_CODES[0];
    }
  }

  showDropdown = false;
  phoneNumber = '';
  searchQuery = '';
  selectedCountry: CountryDropdown = COUNTRY_CODES[0];
  
  private onChange: (value: any) => void = () => {};
  private onTouched: () => void = () => {};

  get filteredCountries(): CountryDropdown[] {
    return COUNTRY_CODES.filter(country => 
      country.name.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
      country.dial_code.includes(this.searchQuery)
    );
  }

  writeValue(value: { countryCode: string; mobile: string }): void {
    if (value) {
      this.updateValues(value);
    }
  }

  private updateValues(value: { countryCode: string; mobile: string }) {
    const country = COUNTRY_CODES.find(c =>  c.dial_code ===  value.countryCode);
    if (country) {
      this.selectedCountry = country;
    }
    this.phoneNumber = value.mobile || '';
    this.emitValue();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  toggleDropdown() {
    this.showDropdown = !this.showDropdown;
    this.searchQuery = '';
  }

  selectCountry(country: CountryDropdown) {
    this.selectedCountry = country;
    this.showDropdown = false;
    this.countryChange.emit(country.dial_code);
    this.emitValue();
  }

  onPhoneNumberChange() {
    this.phoneNumberChange.emit(this.phoneNumber);
    this.emitValue();
  }

  private emitValue() {
    const value = {
      countryCode: this.selectedCountry.dial_code || '+1',
      phoneNumber: this.phoneNumber
    };
    this.onChange(value);
    this.onTouched();
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    const target = event.target as HTMLElement;
    if (!target.closest('.country-select')) {
      this.showDropdown = false;
    }
  }
}
